import React from 'react'
import { Transformation } from 'cloudinary-react'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'
import DfbImage from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_image'
import DfbParagraph from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph'
import DfbAnchor from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_anchor'
import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'
import DfbButton from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_button'

const MHero = ({ data, isBrand, brand, isSubPage }) => {
  const t = useTranslations()
  const { image, headline, subline, overline, link, alternative, cta_buttons } = data[0] || {}
  const hasImage = image && image !== '0'
  const heroImageHeight = brand === 'employer-branding' || !isSubPage ? '666' : '333'
  const anchorAsButton = brand === 'employer-branding'
  let className = isBrand && hasImage ? 'm-Hero--subbrand' : hasImage ? 'm-Hero--overlay' : 'm-Hero--blank'
  className = isSubPage ? `${className} m-Hero--small` : className

  return (
    <Section baseClass="m-Hero" data={data} className={className} defaultPadding={hasImage ? 'small' : 'large'}>
      {hasImage && (
        <div className="m-Hero-imageContainer">
          <DfbImage image={image} add_class="m-Hero-image u-Image--xs u-Image-cover" data-object-fit aspect_ratio="16:9">
            <Transformation crop="fill" gravity="faces:center" width="1920" height={heroImageHeight} quality="auto" fetchFormat="auto" />
          </DfbImage>
        </div>
      )}
      <div className="m-Hero-wrapper">
        <div className="m-Hero-container">
          {overline && <DfbParagraph text={overline} add_class="m-Hero-overline" />}
          {headline && <DfbHeadline headline={headline} headline_level="h1" add_class="m-Hero-headline" />}
          {subline && <DfbParagraph text={subline} add_class={`m-Hero-subline ${hasImage ? 'u-Theme-dark' : ''}`} />}
          {link?.url && anchorAsButton && (
            <div className="m-Hero-button">
              <DfbButton add_class="u-Theme-dark" link={link.url} text={alternative || t('dfb_anchor.morelink')} tagName="a" />
            </div>
          )}
          {link?.url && !anchorAsButton && (
            <DfbAnchor
              tagName="a"
              secondary
              link={link.url}
              text={alternative || t('dfb_anchor.morelink')}
              add_class="m-Hero-anchor u-Theme-dark"
            />
          )}
          {cta_buttons && (
            <div style={{ paddingTop: '2rem', display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
              {cta_buttons.map(
                (button) =>
                  (button.layout === 'apple' || button.layout === 'google') && (
                    <a href={button.link} target="_blank" rel="noopener noreferrer">
                      <img
                        height="60px"
                        style={{ padding: button.layout === 'apple' ? '6px 0' : undefined }}
                        src={button.layout === 'apple' ? '/images/apple_app_store.svg' : '/images/google_play.png'}
                        alt={button.layout === 'apple' ? 'Apple App Store' : button.layout === 'google' ? 'Google Play Store' : ''}
                      />
                    </a>
                  )
              )}
            </div>
          )}
        </div>
      </div>
      {isBrand && hasImage && <div className="m-Hero-playground"></div>}
    </Section>
  )
}

export default MHero
